import { render } from "./ContentArea.vue?vue&type=template&id=57b05900&ts=true"
import script from "./ContentArea.vue?vue&type=script&lang=ts"
export * from "./ContentArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__